import request from './request'

//修改密码发送验证码
export function _sendCode(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/admin/code',
  })
  return request(config)
}
//确认修改密码
export function _changePasswordSave(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/admin/update-password',
  })
  return request(config)
}
